export const pageService = {
    getContentPage: (data) => window.axios.post('get-content-page', data),
    addContentPage: (data) => window.axios.post('add-content-page', data),
    deleteContentPage: (data) => window.axios.post('delete-content-page', data),
    getContentPageById: (data) => window.axios.post('get-content-page-by-id', data),
    editContentPage: (data) => window.axios.post('edit-content-page', data),
};